import feathers from '@feathersjs/client';
import { disallow } from 'feathers-hooks-common';
const { FeathersError } = feathers.errors;

const uploadDocument = async (context) => {
  const { file, name, ...data } = context.data;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('name', name);

  const response = await fetch(process.env.REACT_APP_DOCUMENTS_WORKER_URL, {
    method: 'POST',
    headers: { Authorization: context.params.headers.Authorization },
    body: formData
  });

  if (response.ok) {
    const { public_id, format } = await response.json();
    context.data = { ...data, name, public_id, format };
  } else {
    const error = await response.json();
    throw new FeathersError(error);
  }

  return context;
};

const compressImage = async (context) => {
  const { file } = context.data;

  if (!file || !file.type.startsWith('image/')) {
    return context;
  }

  const imageBitmap = await createImageBitmap(file);
  const canvas = document.createElement('canvas');
  canvas.width = imageBitmap.width;
  canvas.height = imageBitmap.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(imageBitmap, 0, 0);

  const compressed = await new Promise((resolve) => {
    return canvas.toBlob(resolve, file.type, 0.8);
  });

  const newFile = new File([compressed], file.name, {
    type: compressed.type,
    lastModified: Date.now()
  });

  context.data = {
    ...context.data,
    file: newFile
  };

  return context;
};

export default {
  before: {
    all: [],
    find: [],
    get: [],
    create: [compressImage, uploadDocument],
    update: [],
    patch: [],
    remove: [disallow()]
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
